<!-- <div [hidden]="dataCount < 2" [@loadedFadeAnimation]="'visible'" class="mt-3"> -->
<div [style.opacity]="dataCount < 2 ? '0' : '1'" [style.visibility]="dataCount < 2 ? 'hidden' : 'visible'"
  class="fadeIn mt-3">
  <div class="cta_with_button align-items-center bg-extralight">
    <div class="total__gastos">
      <h4>TODAS {{articulo}} DESPESAS</h4>
    </div>
    <div class="bonus-data">
      <div class="item">O MEU BONÚS MARKETING ANUAL: <strong class="figure">{{budgetModel.TotalBudget}} €</strong></div>
      <div class="item">BONÚS MARKETING DISPONÍVEL: <strong class="figure">{{budgetModel.RemainConfString}} €</strong>
      </div>
    </div>
    <div class="total__gastos">
      <div *ngIf="idDistrib">
        <a (click)="goToNewExpense()" class="btn-black btn-lg"><fa-icon [icon]="['fas','plus']"></fa-icon> FAZER NOVO
          PEDIDO</a>
      </div>
    </div>
  </div>

  <div class="accordion" id="accordionAdvancedSearch">
    <div class="accordion-item border-bottom">
      <div class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#collapseAdvancedSearchOne"
          aria-expanded="false" aria-controls="collapseAdvancedSearchOne">
          <img src="/assets/images/icons/ico_info.svg" width="18" class="mb-1"><strong class="orange mx-1">PESQUISA
            AVANÇADA DE DESPESAS</strong>
          <small>(Exibir esta opção para usar os filtros avançados)</small>
        </button>
      </div>

      <div id="collapseAdvancedSearchOne" class="accordion-collapse collapse" aria-labelledby="headingTwo"
        data-bs-parent="#accordionAdvancedSearch">
        <div class="accordion-body border-top pt-3 pb-0">
          <div class="row row-5-1">
            <div *ngIf="distributorsList.length>0" class="col mb-2">
              <div class="form-group form-float">
                <label class="form-label">Concessionário</label>
                <select2 [(ngModel)]="distributorDefaultValue" (close)="getDistribValue($event)"
                  [disabled]="disableDistributor" [value]="distributorDefaultValue" id="distributor"
                  [data]="distributorsList" class="select2"></select2>
              </div>
            </div>
            <div *ngIf="districtsList.length>0" class="col mb-2">
              <div class="form-group form-float">
                <label class="form-label">Zona</label>
                <select2 [(ngModel)]="districtDefaultValue" (close)="getDistrictValue($event)"
                  [disabled]="disableDistrict" [value]="districtDefaultValue" id="district" [data]="districtsList"
                  class="select2"></select2>
              </div>
            </div>
            <div *ngIf="districtsManagersList.length>0" class="col mb-2">
              <div class="form-group form-float">
                <label class="form-label">Chefe de zona</label>
                <select2 [(ngModel)]="districtManagerDefaultValue" (close)="getDistrictManagersValue($event)"
                  [disabled]="disableDistrictManager" [value]="districtManagerDefaultValue" id="districtManager"
                  [data]="districtsManagersList" class="select2"></select2>
              </div>
            </div>
            <div *ngIf="meses.length>0" class="col mb-2">
              <div class="form-group form-float">
                <label class="form-label">Mês</label>
                <select2 [(ngModel)]="monthDefaultValue" (close)="getMonthValue($event)" [value]="monthDefaultValue"
                  id="month" [data]="meses" class="select2"></select2>
              </div>
            </div>
            <div *ngIf="anios.length>0" class="col mb-2">
              <div class="form-group form-float">
                <label class="form-label">Ano</label>
                <select2 [(ngModel)]="yearDefaultValue" (close)="getYearValue($event)" [value]="yearDefaultValue"
                  id="year" [data]="anios" class="select2"></select2>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-group form-float">
                <label class="form-label" for="campaignType">Tipo de campanha</label>
                <select2 [value]="campaignTypeDefaultValue" (close)="getCampaignTypeValue($event)" id="campaignType"
                  [(ngModel)]="campaignTypeDefaultValue" [data]="campaignTypes" [placeholder]="'Campanhas'"
                  class="select2"></select2>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-group form-float">
                <label class="form-label" for="media">Materiais</label>
                <select2 [value]="mediaDefaultValue" id="media" (close)="getMediaValue($event)"
                  [(ngModel)]="mediaDefaultValue" [data]="medias" [placeholder]="'Meio'" class="select2">
                </select2>

              </div>
            </div>

            <div class="col mb-3">
              <div class="form-group form-float">
                <label class="form-label" for="format">Formato</label>
                <select2 [value]="formatDefaultValue" (close)="getFormatValue($event)" [(ngModel)]="formatDefaultValue"
                  id="format" [data]="formats" [placeholder]="'FORMATO'" class="select2">
                </select2>

              </div>
            </div>

            <!-- <div class="col mb-3">
              <div class="form-group form-float">
                <label class="form-label" for="support">Meios</label>
                <select2 [value]="supportDefaultValue" (close)="getSupportValue($event)" [(ngModel)]="supportDefaultValue" id="support" [data]="supports" [placeholder]="'Canal'" class="select2">
                </select2>

              </div>
            </div> -->
            <div class="col mb-3">
              <div class="form-group form-float">
                <label class="form-label" for="status">Estado</label>
                <select2 [value]="statusDefaultValue" (close)="getStatusValue($event)" id="status"
                  [(ngModel)]="statusDefaultValue" [data]="status" [placeholder]="'ESTADOS'" class="select2"></select2>
              </div>
            </div>
            <div class="col-xxl-12 mb-3 align-self-end text-end">
              <button type="button" (click)="getDashboard(true)" class="btn-search float-xxl-end"><fa-icon
                  [icon]="['fas','search']" class="fa-lg"></fa-icon><span
                  class="visually-hidden">Filtrar</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="showBudget !== undefined && !showBudget" class="my-bonus-marketing">
    <div class="header-my-bonus">
      <div class="title">
        BONÚS MARKETING {{yearBudget}} <span class="title-note">(com base em <strong>faturas</strong> aprovadas)</span>
      </div>
      <div class="cont-data-bonus">
        <div *ngIf="budgetModel && budgetModel.Free" class="cont-total-bonus bg-offer">
          <div class="mini-subtitle">
            OFERTA
          </div>
          <div class="total-bonus">
            {{budgetModel.Free}} €
          </div>
        </div>
        <div class="cont-total-bonus bg-bonus">
          <div class="mini-subtitle">
            BONUS
          </div>
          <div class="total-bonus">
            {{budgetModel.TotalBudget}} €
          </div>
        </div>

      </div>
    </div>

    <ng-template #tipBonusProgress>
      <div *ngIf="budgetModel.TotalSpentConf !== '0,00'"><strong>Consumido: </strong>{{ budgetModel.TotalSpentConf }}
      </div>
      <div *ngIf="budgetModel.TotalExtraSpentConf"><strong>Excedente: </strong>{{ budgetModel.TotalExtraSpentConf }}
      </div>
      <div *ngIf="budgetModel.RemainConfString !== '0,00'"><strong>Disponível: </strong>{{ budgetModel.RemainConfString
        }}</div>
      <div *ngIf="budgetModel.TotalSpentProv !== '0,00'"><strong>Previsto: </strong>{{ budgetModel.TotalSpentProv }}
      </div>
    </ng-template>

    <div class="cont-bonus-progress" [ngbTooltip]="tipBonusProgress" placement="bottom">
      <div class=" cont-progress-indicator">
        <div class="item-indicator">
        </div>
        <div class="item-indicator">
          <div>25%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>50%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>75%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>100%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
      </div>

      <div class="bonus-progress">
        <div #dataBar class="progress-bar-consumed" *ngIf="budgetModel.TotalSpentConf !== '0,00'"
          [style.width.%]="budgetModel.SpentConfPercent">
          <div #dataEl class="data"
            [style.left.px]="getProgressDataPosition(dataBar, dataEl, budgetModel.SpentConfPercent)">
            {{budgetModel.TotalSpentConf}} €</div>
        </div>
        <div #dataBarExtra class="progress-bar-extra" *ngIf="budgetModel.TotalExtraSpentConf"
          [style.width.%]="getExtraPercent(budgetModel.TotalBudget, budgetModel.TotalExtraSpentConf)">
          <div #dataElExtra class="data"
            [style.left.px]="getProgressDataPosition(dataBarExtra, dataElExtra, getExtraPercent(budgetModel.TotalBudget, budgetModel.TotalExtraSpentConf))">
            {{budgetModel.TotalExtraSpentConf}} €</div>
        </div>
        <div class="totalData" *ngIf="!budgetModel.TotalExtraSpentConf">
          {{budgetModel.RemainConfString}} €
        </div>
      </div>

      <div class="bonus-expected">
        <div #dataBarExp class="progress-bar-expected" *ngIf="budgetModel.TotalSpentProv !== '0,00'"
          [style.width.%]="budgetModel.SpentProvPercent">
          <div #dataElExp class="data"
            [style.left.px]="getProgressDataPosition(dataBarExp, dataElExp, budgetModel.SpentProvPercent)">
            {{budgetModel.TotalSpentProv}} €</div>
        </div>
      </div>

    </div>
    <div class="cont-legend">
      <div class="item">
        <div class="square bonusConsumed"></div>
        <div>CONSUMIDO</div>
      </div>
      <div *ngIf="budgetModel.TotalExtraSpentConf" class="item">
        <div class="square" style="background-color: #E50000;"></div>
        <div>EXCEDENTE</div>
      </div>
      <div class="item">
        <div class="square bonusAvailable"></div>
        <div>DISPONÍVEL</div>
      </div>
      <div class="item">
        <div class="square bonusExpected"></div>
        <div>CONSUMO PREVISTO <small>(despesas aprovadas na plataforma + despesas pendentes de aprovação)</small></div>
      </div>

    </div>
  </div>

  <div [hidden]="!showBudgetLastYear" class="my-bonus-marketing">
    <div class="header-my-bonus">
      <div class="title">
        BONÚS MARKETING {{yearBudgetLastYear}} <span class="title-note">(com base em <strong>faturas</strong>
          aprovadas)</span>
      </div>
      <div class="cont-total-bonus">
        <div class="mini-subtitle">
          BONUS
        </div>
        <div class="total-bonus">
          {{budgetModelLastYear.TotalBudget}} €
        </div>
      </div>
    </div>

    <ng-template #tipBonusProgress2>
      <div *ngIf="budgetModelLastYear.TotalSpentConf !== '0,00'"><strong>Consumido: </strong>{{
        budgetModelLastYear.TotalSpentConf }}</div>
      <div *ngIf="budgetModelLastYear.TotalExtraSpentConf"><strong>Excedente: </strong>{{
        budgetModelLastYear.TotalExtraSpentConf }}</div>
      <div *ngIf="budgetModelLastYear.RemainConfString !== '0,00'"><strong>Disponível: </strong>{{
        budgetModelLastYear.RemainConfString }}</div>
      <div *ngIf="budgetModelLastYear.TotalSpentProv !== '0,00'"><strong>Previsto: </strong>{{
        budgetModelLastYear.TotalSpentProv }}</div>
    </ng-template>

    <div class="cont-bonus-progress" [ngbTooltip]="tipBonusProgress2" placement="bottom">
      <div class="cont-progress-indicator">
        <div class="item-indicator">
        </div>
        <div class="item-indicator">
          <div>25%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>50%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>75%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
        <div class="item-indicator">
          <div>100%</div>
          <img src="assets/images/icons/progress-arrow.svg" />
        </div>
      </div>

      <div class="bonus-progress">
        <div #dataBar2 class="progress-bar-consumed" *ngIf="budgetModelLastYear.TotalSpentConf !== '0,00'"
          [style.width.%]="budgetModelLastYear.SpentConfPercent">
          <div #dataEl2 class="data"
            [style.left.px]="getProgressDataPosition(dataBar2, dataEl2, budgetModelLastYear.SpentConfPercent)">
            {{budgetModelLastYear.TotalSpentConf}} €</div>
        </div>
        <div #dataBarExtra2 class="progress-bar-extra" *ngIf="budgetModelLastYear.TotalExtraSpentConf"
          [style.width.%]="getExtraPercent(budgetModelLastYear.TotalBudget, budgetModelLastYear.TotalExtraSpentConf)">
          <div #dataElExtra2 class="data"
            [style.left.px]="getProgressDataPosition(dataBarExtra2, dataElExtra2, getExtraPercent(budgetModelLastYear.TotalBudget, budgetModelLastYear.TotalExtraSpentConf))">
            {{budgetModelLastYear.TotalExtraSpentConf}} €</div>
        </div>
        <div class="totalData" *ngIf="!budgetModelLastYear.TotalExtraSpentConf">
          {{budgetModelLastYear.RemainConfString}} €
        </div>
      </div>

      <div class="bonus-expected">
        <div #dataBarExp2 class="progress-bar-expected" *ngIf="budgetModelLastYear.TotalSpentProv !== '0,00'"
          [style.width.%]="budgetModelLastYear.SpentProvPercent">
          <div #dataElExp2 class="data"
            [style.left.px]="getProgressDataPosition(dataBarExp2, dataElExp2, budgetModelLastYear.SpentProvPercent)">
            {{budgetModelLastYear.TotalSpentProv}} €</div>
        </div>
      </div>

    </div>
    <div class="cont-legend">
      <div class="item">
        <div class="square bonusConsumed"></div>
        <div>CONSUMIDO</div>
      </div>
      <div *ngIf="budgetModelLastYear.TotalExtraSpentConf" class="item">
        <div class="square" style="background-color: #E50000;"></div>
        <div>EXCEDENTE</div>
      </div>
      <div class="item">
        <div class="square bonusAvailable"></div>
        <div>DISPONÍVEL</div>
      </div>
      <div class="item">
        <div class="square bonusExpected"></div>
        <div>CONSUMO PREVISTO <small>(despesas aprovadas na plataforma + despesas pendentes de aprovação)</small></div>
      </div>

    </div>
  </div>

  <div class="row align-items center my-4">
    <div class="col">
      <h5>Histórico de despesas</h5>
    </div>
    <div class="col-auto">
      <div class="cont_btn_download">
        <a href="https://blobstihlportugal.blob.core.windows.net/images/Documentos/DESPESAS_2026.pdf" target="_blank"
          rel="noopener noreferrer" class="btn-orange-border btn-icon float-end" download>
          <div class="svg-icon">
            <svg viewBox="0 0 150 150">
              <use xlink:href="assets/images/icons/ico_link_auto.svg#img"
                href="assets/images/icons/ico_download_auto.svg#img">
              </use>
            </svg>
          </div>
          Descarregar o Manual passo-a-passo para Submissão do Pedido
        </a>
        <button type="button" (click)="DownloadExcel()" class="btn-orange-border btn-icon float-end">
          <div class="svg-icon"><svg viewBox="0 0 150 150">
              <use xlink:href="assets/images/icons/ico_link_auto.svg#img"
                href="assets/images/icons/ico_download_auto.svg#img"></use>
            </svg>
          </div>
          Download todas as despesas
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="idDistrib===undefined" class="row align-items center my-4">
    <div class="col">
      <h5>liquidações mensais</h5>
    </div>
    <div *ngIf="yearMonthlyExcelData" class="col-auto">
      <div class="form-group form-float select_gastos">
        <label class="form-label"><strong>Ano</strong></label>
        <select2 [(ngModel)]="yearMonthlyExcelSelected" [value]="yearMonthlyExcelSelected" id="yearExcel"
          [data]="yearMonthlyExcelData" class="select2 "></select2>
      </div>
      <button type="button" (click)="DownloadMonthlyExcel()" class="btn-orange-border btn-icon float-end mt-2">
        <div class="svg-icon"><svg viewBox="0 0 150 150">
            <use xlink:href="assets/images/icons/ico_link_auto.svg#img"
              href="assets/images/icons/ico_download_auto.svg#img"></use>
          </svg>
        </div>
        Descarregar liquidações
      </button>
    </div>
  </div>

  <div class="alert alert-light alert-withicon" role="alert">
    <div class="alert-icon">
      <img src="/assets/images/icons/ico_info.svg" width="18" class="mt-0">
    </div>
    <div class="alert-text lead">
      <strong class="orange">NOTA:</strong>
      <ul>
        <li>Use a barra inferior da tabela de despesas para ver toda a informação de
          cada despesa.</li>
        <li>O filtro do mês realiza a pesquisa com base na data de aprovação.</li>
      </ul>
    </div>
  </div>

  <div class="dt-wrap">
    <table id="tblEvaluation" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
      class="table data-tables dataTable condensed-table no-footer w-100">
      <thead>
        <tr>
          <th class="text-center w-6">Código</th>
          <th class="text-center">Concessionário</th>
          <th class="text-center">Data da<br>despesa</th>
          <th class="text-center">Data do<br>pedido</th>
          <th class="text-center w-8">Data da<br>aprovação</th>
          <th class="text-center w-8">Data prevista<br>para emissão do crédito</th>
          <th class="text-center w-8">Estado</th>
          <th class="text-center w-8">Campanha</th>
          <th class="text-center w-8">Tipo de<br>campanha</th>
          <th class="text-center w-6">Montante total <br> estimado (s/ IVA)</th>
          <th class="text-center w-8">€ de comparticipação<br>STIHL (s/ IVA)</th>
          <th [hidden]="idDistrib!==undefined" class="text-center w-8">Orçamento</th>
          <th [hidden]="idDistrib!==undefined" class="text-center w-8">Bónus Disponível</th>
          <th class="text-center w-8">Opções</th>
        </tr>
      </thead>
    </table>
  </div>

  <div class="accordion" id="accordionExpenseSummary">
    <div class="accordion-item border-bottom">
      <div class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#collapseExpenseSummaryOne"
          aria-expanded="false" aria-controls="collapseExpenseSummaryOne">
          <img src="/assets/images/icons/ico_info.svg" width="18" class="mb-1"><strong class="orange mx-1">RESUMO DE
            DESPESAS</strong>
          <small>(Exiba esta opção para ver o resumo das suas despesas)</small>
        </button>
      </div>
      <div id="collapseExpenseSummaryOne" class=" accordion-collapse collapse" aria-labelledby="headingTwo"
        data-bs-parent="#accordionExpenseSummary">
        <div class="accordion-body border-top">
          <div class="cuadros row-4-1 mt-3">
            <div class="col mb-2" *ngFor="let elem of dashboardModel.Campaigns">
              <div class="row mx-0">
                <div class="col-md-4 cuadro_camp_orange strong left"> {{elem.Name}}</div>
                <div class="col-md-8 cuadro_camp_grey strong left">{{elem.Amount}} € &nbsp;&nbsp; ({{elem.Percentage}}
                  %)</div>
              </div>
            </div>
          </div>
          <div class="circulos row-4-1 mt-3">
            <div class="text-center mb-3">
              <div class="circulo_gastos border-orange">{{dashboardModel.TotalExpenses}}</div>
              <div class="strong mt-2">DESPESAS TOTAIS</div>
            </div>
            <div class="text-center mb-3">
              <div class="circulo_gastos border-green">{{dashboardModel.ApprovedExpenses}}</div>
              <div class="strong mt-2">DESPESAS APROVADAS PENDENTES DO ENVIO DE FATURA</div>
            </div>
            <div class="text-center mb-3">
              <div class="circulo_gastos border-red"> {{dashboardModel.PendingInvoices}}</div>
              <div class="strong mt-2">FATURAS PENDENTES DE ENVIAR</div>

            </div>
            <div class="text-center mb-3">
              <div class="circulo_gastos border-green">{{dashboardModel.ApprovedInvoices}}</div>
              <div class="strong mt-2">FATURAS APROVADAS</div>
            </div>
          </div>

          <hr class="orange mt-3">

          <div class="row mt-3 mb-4">
            <div class="row">
              <div class="col-lg-4 col-xs-6" id="chartCampaignType"></div>
              <div class="col-lg-4 col-xs-6" id="chartMedia"></div>
              <div class="col-lg-4 col-xs-6" id="chartFormat"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>